@let selected = bucket();
<app-drawer-layout
  class="bucket-drawer-wrapper"
  data-testid="bucket-drawer"
  body="flush"
  [title]="selected?.name ?? 'Budget'"
  [subtitle]="selected ? headerSubtitle(selected) : undefined"
  [state]="layoutState()"
  [errorMessage]="layoutErrorMessage()"
>
  <!-- Single-root @if blocks so each piece is projected into its header slot. -->
  <!-- Transfers is system-managed (LCL-66): no budget progress — flat icon + explainer instead. -->
  @if (selected?.type === 'TRANSFERS') {
    <span drawerLeading class="flex size-12 items-center justify-center text-text-muted" aria-hidden="true">
      <app-ui-icon name="exchange" class="size-8" />
    </span>
  }
  @if (selected && selected.type !== 'TRANSFERS') {
    <app-bucket-progress drawerLeading class="block size-12" [bucket]="selected" />
  }
  @if (selected && !selected.isSetup && !editName) {
    <button
      drawerSubtitle
      appUiButton
      appearance="outline"
      tone="primary"
      size="control"
      type="button"
      class="mt-2"
      (click)="editName = true"
    >
      Rename
    </button>
  }
  @if (selected && selected.isSetup) {
    <app-drawer-stat
      drawerTrailing
      [amount]="null"
      [label]="bucketService.isIncomeAndBehind(selected) ? 'Expected' : 'Balance'"
    >
      <app-balance-amount
        class="[&_.bad]:text-amount-negative [&_.good]:text-amount-positive [&_.warn]:text-amount-negative [&_span]:text-amount-neutral"
        [bucket]="selected"
        [showDecimals]="true"
      />
    </app-drawer-stat>
  }

  @if (selected) {
    <div class="flex min-h-0 flex-1 flex-col">
      @if (!selected.isSetup && editName) {
        <div class="border-b border-border bg-surface-elevated px-6 py-4">
          <form
            #renameBucketForm="ngForm"
            (ngSubmit)="renameBucket(renameBucketForm, selected)"
            class="flex items-end gap-2"
          >
            <app-ui-field class="flex-1" label="Budget Name" [inputId]="'bucket-drawer-rename'">
              <input
                id="bucket-drawer-rename"
                appUiInput
                name="newBucketName"
                type="text"
                [(ngModel)]="selected.name"
                placeholder="Budget Name"
                maxlength="24"
                [autofocus]="true"
                required
              />
            </app-ui-field>
            <button appUiButton appearance="outline" tone="primary" type="submit">Save</button>
          </form>
        </div>
      }

      <!-- Recreate only bucket-scoped tab and form state when the active budget or route tab changes. -->
      @for (activeBucket of bucketContentViews(); track activeBucket.key) {
        <app-bucket
          class="flex h-full min-h-0 flex-1 basis-0 flex-col"
          [bucket]="activeBucket.bucket"
          [initialTab]="initialTab()"
          [isInDrawer]="true"
          [transactionsLoading]="transactionsLoading()"
        />
      }
    </div>
  }
</app-drawer-layout>
